
import BaseBlock from '@headlines/utils/BaseBlock';
import BlockTypeSettings from '@headlines/types/block/100-110/blockType102';

import Grid1 from './Grid1.vue';
import Grid22 from './Grid22.vue';
import Grid23 from './Grid23.vue';
import Grid3 from './Grid3.vue';
import Grid4 from './Grid4.vue';

import { Headline } from '@headlines/types/headline';

interface DataWithSettings {
  data: {
    items: Headline[];
  };
  settings: BlockTypeSettings;
}

interface Computed {
  blocks: {
    name: string;
    data: {
      items: Headline[];
    };
    settings: BlockTypeSettings;
  }[];
}

interface Methods {
  getBlockData: (items: Headline[], amount: number) => DataWithSettings;
}

const defaultSettings = {
  icons: true,
  author: false,
  titleComment: false,
  channel: false,
  category: true,
  adsInject: null,
};

export default BaseBlock<BlockTypeSettings>(defaultSettings).extend<unknown, Methods, Computed, unknown>({
  components: {
    Grid1,
    Grid22,
    Grid23,
    Grid3,
    Grid4,
  },
  computed: {
    blocks() {
      const { getBlockData, data } = this;
      const items = [...data.items];

      const blocks = [];
      const itemsCount = items.length;
      const itemsMod = itemsCount % 5;
      const fullBlockItems = itemsCount - itemsMod;
      const modItems = itemsMod;

      switch (itemsMod) {
        case 4:
          if (itemsCount === modItems) {
            blocks.push({ name: 'Grid4', ...getBlockData(items, modItems) });
          } else {
            blocks.push({ name: 'Grid23', ...getBlockData(items, fullBlockItems) });
            blocks.push({ name: 'Grid22', ...getBlockData(items, modItems) });
          }
          break;
        case 3:
          blocks.push({ name: 'Grid23', ...getBlockData(items, fullBlockItems) });
          blocks.push({ name: 'Grid3', ...getBlockData(items, modItems) });
          break;
        case 2:
          blocks.push({ name: 'Grid23', ...getBlockData(items, fullBlockItems) });
          blocks.push({ name: 'Grid22', ...getBlockData(items, modItems) });
          break;
        case 1:
          blocks.push({ name: 'Grid1', ...getBlockData(items, modItems) });
          blocks.push({ name: 'Grid23', ...getBlockData(items, fullBlockItems) });
          break;
        default:
          blocks.push({ name: 'Grid23', ...getBlockData(items, fullBlockItems) });
      }

      return blocks;
    },
  },
  methods: {
    getBlockData(items, amount) {
      return {
        data: { items: items.splice(0, amount) },
        settings: this.getSettings,
      };
    },
  },
});
